module.exports = __webpack_public_path__ + "media/images/village/thu-2022/icons-e73f56d39ba487120984fd6aef0cfbb4.svg";